/* get view width, height and devicePixelRatio and store in a long life cookie */
import Component from './Component';

export default class DeviceResCookie extends Component {
  load() {
    this.initDeviceResCookie();
    super.load();
  }

  initDeviceResCookie() {

    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const dpr = window.devicePixelRatio;

    // $(window).on('resize', function () {
    //   console.log("window was resized");
    // });

    // save to cookie so server can preload resources for client
    let cookieDate = new Date();
    cookieDate.setFullYear(cookieDate.getFullYear() + 2); // 2 years
    document.cookie = `whr=${vw},${vh},${dpr}; expires=${cookieDate.toUTCString()}; path=/`;

    // getCookie function
    // const getCookieValue = (name) =>
    //   document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";

    // let x = getCookieValue("whr");

    // console.log("cookie value: ", x);
  }
}
